import { ActivityKind } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { Appearance, Design, Size } from '@Components/designConstants';

export const SortBy = {
  MOST_RECENT: 'most_recent',
  PRIORITY: 'priority'
} as const;
export type SortBy = (typeof SortBy)[keyof typeof SortBy];

export const DetailAction = {
  HIDE: 'hide',
  CREATE_TASK: 'create_task',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  DELETE: 'delete'
} as const;
export type DetailActionType = (typeof DetailAction)[keyof typeof DetailAction];

export const BulkAction = {
  STAR: 'star',
  PIN: 'pin',
  SHARE: 'share',
  HIDE: 'hide',
  MARK_TASKS_DONE: 'mark_tasks_done',
  DOWNLOAD: 'download',
  DELETE: 'delete'
} as const;
export type BulkActionType = (typeof BulkAction)[keyof typeof BulkAction];

export const ACTIONS_MENU_CLASS = 'activity-feed-actions-menu';
export const ACTIONS_MENU_POPUP_CLASS = 'activity-feed-actions-menu-popup';
export const ACTIONS_MENU_DESTRUCTIVE_CLASS = 'activity-feed-actions-menu-destructive';

export const URL_PARAMS = {
  SORT: 'sort',
  DATE: 'date',
  DATE_START: 'dateStart',
  DATE_END: 'dateEnd',
  CLIENTS: 'clients',
  IMPORTANCE: 'importance',
  SIGNALS: 'signals',
  CATEGORY: 'category',
  CHANNEL: 'channel',
  SELECTED: 'selected',
  KINDS: 'kinds'
} as const;

// Cache key for the feed, whose pages also carry the counts.
// Shared by the loader hooks and the mutations that patch this cache.
export const EVENTS_QUERY_KEY = ['oracleEvents'] as const;

// Kinds the frontend has designed card + Detail treatments for today. Consumed by the pipeline's
// structural pre-filter (stage 1) alongside the dismissed check — non-supported kinds never
// reach the visible list, so `activities` / `groups` / facet counts all reflect what will
// actually render. Extend this as Meeting / Task / BpAlert designs land.
export const SUPPORTED_KINDS: ReadonlySet<ActivityKind> = new Set([ActivityKind.EVENT]);

// Shared visual treatment for the small "ghost" IconButtons scattered around the feed —
// prev/next/close in the detail header, share/star/pin/more in the detail badges row, and the
// hover-revealed share/star/pin row on each card. Spread these onto the <IconButton> before any
// per-site props (onClick, disabled, etc.).
export const GHOST_ICON_BUTTON_PROPS = {
  size: Size.SM,
  appearance: Appearance.EMPTY,
  design: Design.NEUTRAL
} as const;

// Matches the CHECK constraint on oracle_activity_comments.body; markdown formatting syntax
// eats into the raw character budget, so the limit is higher than a plain-text equivalent.
export const COMMENT_BODY_MAX = 4096;
